import React, { Component } from 'react';
import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { Panel, PanelType } from 'office-ui-fabric-react/lib/Panel';
import { MessageBars } from '../Outils/MessageBars';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import { Toggle } from 'office-ui-fabric-react/lib/Toggle';

import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';

import Scriba from 'react-scriba';
import { Immocom } from '../../specifique/immocom';
import { DataReservation } from '../../data/DataReservation';

/****************************************************************
 PROPS:
    idOperation
    idReservation
    peutModifier

    onAffiche : bool

    onEnregistrementFiche : méthode
    onAnnuleFiche : méthode
    
    classname : classe CSS (string)
    classnameinner : classe CSS (string)
****************************************************************/

var objetState = {
    reservation: {},

    enCoursDeTraitement: false,
    messageEnCoursTraitement: '',

    //peutModifierBlocNotaire: false,

    hideMessageBarError: true,
    errorMessage: '',
    hideMessageBarWarning: true,
    warningMessage: '',

    onActiveBoutonEnregistrer: false,

};

export class FicheFraisNotaire extends Component {
    _creationContent() {
        return (
            <Panel
                isOpen={this.props.onAffiche}
                headerText="Modifier les frais de notaire"
                type={PanelType.medium}
                onDismiss={() => this._onAnnulation()}
                onOpen={() => this._onOpen()}
                closeButtonAriaLabel="Fermer"
                onRenderFooterContent={this._onRenderFooterContent}
            >
                <div className={this.props.classname}>
                    <div className={this.props.classnameinner}>
                        <div className="ms-Grid" dir="ltr">
                            <MessageBars
                                errorMessage={this.state.errorMessage}
                                warningMessage={this.state.warningMessage}
                                onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                                onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
                            />

                            {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

                            <div className="ms-Grid-row">
                                <div className="ms-Grid-col ms-sm12" name="divFraisNotaire">
                                    <Toggle
                                        label="Frais de notaire offerts"
                                        checked={this.state.reservation.fraisNotaireOffert}
                                        onText="Oui"
                                        offText="Non"
                                        onChange={(e, isChecked) => Scriba.state().setObjetPropriete(this, "reservation", "fraisNotaireOffert", isChecked, this._onVerificationFormulaire) }
                                    />
                                </div>
                                <div className="ms-Grid-col ms-sm12" name="divMontantNotaire">
                                    <TextField // Note KP : TextFieldNombre en cours de test
                                        //disabled={!this.state.reservation.fraisNotaireOffert}
                                        label="Montant frais de notaire"
                                        value={Scriba.officeUI().textField().nombre().ValeurChampNombreObjetAvecPrecisionAfficheeSpecifiee(this, 'reservation', 'montantFraisNotaire', false, 2)}
                                        onFocus={() => Scriba.officeUI().textField().nombre().onFocusTextFieldNombreObjet(this, 'reservation', 'montantFraisNotaire')}
                                        onBlur={e => Scriba.officeUI().textField().nombre().onBlurTextFieldNombreObjet(this, 'reservation', 'montantFraisNotaire', e.target.value, 'fr', this._onVerificationFormulaire)}
                                        onGetErrorMessage={e => Scriba.officeUI().textField().nombre().onGetErrorMessageTextFieldNombre(this, 'montantFraisNotaire', e, false, 2)}
                                        deferredValidationTime={0}
                                        suffix="€"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Panel>
        );
    }

    constructor(props) {
        super(props);

        this.state = objetState;
    }

    _onInit() {
        this.setState(objetState);
    }

    _chargementDonnees() {
        let idOperationRenseigneeEtDifferent = Immocom.getSiPropsRenseigneeEtDifferenteDeLaValeurEnParametre(this.props.idOperation, [0, this.state.idOperation]);
        let idReservationRenseigneeEtDifferent = Immocom.getSiPropsRenseigneeEtDifferenteDeLaValeurEnParametre(this.props.idReservation, [0, this.state.idReservation]);

        if (idOperationRenseigneeEtDifferent && idReservationRenseigneeEtDifferent) {

            this.setState({
                enCoursDeTraitement: true,
                messageEnCoursTraitement: 'Chargement des frais de notaire'
            });

            let ficheReservation_Simple = DataReservation._ficheReservation_Simple(this.props.idOperation, this.props.idReservation);

            ficheReservation_Simple
                .then(responseFetch => {
                    let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                    if (retourVerif === null) {
                        let objetData = responseFetch.reponseAPIobjet;

                        let stateTemp = {};
                        stateTemp.idReservation = this.props.idReservation;
                        stateTemp.idOperation = this.props.idOperation;
                        stateTemp.titrePanelNotaire = 'Modifier le notaire';

                        //stateTemp.peutModifierBlocNotaire = this.props.peutModifierBlocNotaire;

                        stateTemp.reservation = objetData[0];

                        Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp);

                        this._onVerificationFormulaire();
                    }
                    else {
                        Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                    }
                });
        }
    }

    //_validationFormulaire(item) {
    //    let estValide = true;

    //    // Si l'objet n'est pas vide
    //    if (!(Object.keys(item).length === 0 && item.constructor === Object)) {
    //        estValide = (item.idReservation !== 0 & item.idReservation !== null & this.props.peutModifier)
    //    }
    //    else {
    //        estValide = false;
    //    }

    //    return estValide;
    //}

    _onEnregistrement = () => {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Enregistrement du notaire en cours'
        });

        //YD : 15/10/2020
        //mise en commentaire car cela ne paraît pas logique de ne pas pouvoir renseigner un montant s'ils ne sont pas offerts
        //if (!this.state.reservation.fraisNotaireOffert)
        //    this.state.reservation.montantFraisNotaire = 0;

        let miseAJourReservation = DataReservation._miseAJourReservation(this.props.idOperation, this.props.idReservation, this.state.reservation);
        
        miseAJourReservation
            .then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                if (retourVerif === null) {
                    let objetData = responseFetch.reponseAPIobjet;

                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, { ...this.state });

                    this.props.onEnregistrementFiche(objetData);
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                }
            });
    }

    _onAnnulation = () => {
        this._onInit();
        this.props.onAnnuleFiche();
    }

    _onVerificationFormulaire() {
        Immocom.fiche()._validationFormulaire(this, 'FraisNotaireReservation', this.state.reservation, (this.state.reservation.idReservation > 0 ? 'Modification' : 'Création'));
    }

    _onRenderFooterContent = () => {
        return (
            <div>
                <PrimaryButton name="btnEnregistrerNotaire" onClick={() => this._onEnregistrement()} className="marginRight8px" disabled={!this.state.onActiveBoutonEnregistrer}>Enregistrer</PrimaryButton>
                <DefaultButton onClick={() => this._onAnnulation()}>Annuler</DefaultButton>
            </div>
        );
    };

    _onOpen = () => {
        if (!this.state.enCoursDeTraitement)
            this._chargementDonnees();
    }

    componentDidMount() {
        //if ((this.props.idReservation !== this.state.idReservation) && (this.props.idOperation !== 0 && this.props.idOperation !== this.state.idOperation)) {
        //    this._chargementDonnees();
        //}
    }

    componentWillUnmount() {
    }

    componentDidUpdate() {
        if ((this.props.idReservation !== this.state.idReservation) && (this.props.idOperation !== 0 && this.props.idOperation !== this.state.idOperation) && !this.state.enCoursDeTraitement) {
            this._chargementDonnees();
        }
    }

    render() {
        return this._creationContent();
    }
}